import { ref, reactive, nextTick, watch } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-294eb16c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alipay-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const _hoisted_3 = {
  class: "flex-list",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_4 = {
  class: "notice-text"
};
const _hoisted_5 = {
  class: "notice-desc"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://ewe8txd9jt.feishu.cn/sheets/shtcnFl01iQTMCceH3uiGv3mEVc?sheet=f6CglY"
}, " 《域名隔离表》 ", -1));
const _hoisted_7 = {
  class: "ali-pkg-content"
};
const __default__ = {
  name: 'AlipayBaseConfig'
};
import SvgIcon from '@/components/SvgIcon.vue';
import { message } from 'ant-design-vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const alipayRef = ref(null); // 支付宝app支付ref
    const alipayForm = reactive({
      channelRate: 0.01,
      appId: '',
      mchId: null,
      publicKey: '',
      appPublicKey: '',
      appPrivateKey: '',
      appGateway: 'https://pay.wedobest.com.cn:8449/PayServer/pay/callbackAliPay',
      mchName: '',
      pkgList: [{
        pkg: ''
      }]
    }); // 支付宝app支付
    const channelRateList = ref([]); // 费率
    const validateForm = () => {
      var _alipayRef$value;
      (_alipayRef$value = alipayRef.value) === null || _alipayRef$value === void 0 || _alipayRef$value.validate().then(() => {
        // pkg不能为空
        if (alipayForm.pkgList.some(item => !item.pkg)) {
          message.error('包名不能为空');
          return;
        }
        emit('submitForm', alipayForm);
      }).catch(e => void 0);
    };
    const addAliPkg = () => {
      if (!alipayForm.pkgList.length) {
        alipayForm.pkgList.push({
          pkg: ''
        });
      } else {
        let flag = alipayForm.pkgList.some(item => !item.pkg);
        if (!flag) {
          alipayForm.pkgList.push({
            pkg: ''
          });
          nextTick(() => {
            var _document$querySelect;
            (_document$querySelect = document.querySelector('.ali-pkg-content')) === null || _document$querySelect === void 0 || _document$querySelect.scrollTo(0, 9999);
          });
        } else {
          message.error('请先填写完整');
        }
      }
    }; // 添加支付宝包名
    const deleteAliPkg = index => {
      alipayForm.pkgList.splice(index, 1);
    }; // 删除支付宝包名
    watch(() => props.detailForm, n => {
      if (n) {
        alipayForm.pkgList = n.pkgListTemp ? JSON.parse(n.pkgListTemp) : [{
          pkg: ''
        }];
        alipayForm.appId = n.appId;
        alipayForm.mchName = n.mchName;
        alipayForm.publicKey = n.publicKey;
        alipayForm.appPublicKey = n.appPublicKey;
        alipayForm.appPrivateKey = n.appPrivateKey;
        alipayForm.appGateway = n.appGateway;
        alipayForm.channelRate = n.channelRate;
        channelRateList.value = n.channelRateList || [{
          label: '1%',
          value: '0.01'
        }];
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: alipayForm,
        ref_key: "alipayRef",
        ref: alipayRef,
        rules: __props.rules,
        name: "alipay-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: alipayForm.appId,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => alipayForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: alipayForm.mchName,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => alipayForm.mchName = $event),
            disabled: "",
            maxlength: 200
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "channelRate",
          label: "费率："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: alipayForm.channelRate,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => alipayForm.channelRate = $event),
            options: channelRateList.value
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("使用支付宝支付功能将收取1%手续费")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "publicKey",
          label: "支付宝公钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: alipayForm.publicKey,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => alipayForm.publicKey = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appPublicKey",
          label: "应用公钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: alipayForm.appPublicKey,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => alipayForm.appPublicKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appPrivateKey",
          label: "应用私钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: alipayForm.appPrivateKey,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => alipayForm.appPrivateKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appGateway",
          label: "应用网关："
        }, {
          default: _withCtx(() => {
            var _alipayForm$appGatewa, _alipayForm$appGatewa2;
            return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(" https:// "), _createElementVNode("span", null, _toDisplayString((_alipayForm$appGatewa = alipayForm.appGateway) === null || _alipayForm$appGatewa === void 0 || (_alipayForm$appGatewa = _alipayForm$appGatewa.split('https://')[1]) === null || _alipayForm$appGatewa === void 0 ? void 0 : _alipayForm$appGatewa.split('/PayServer')[0]), 1), _createTextVNode(" " + _toDisplayString('/PayServer' + ((_alipayForm$appGatewa2 = alipayForm.appGateway) === null || _alipayForm$appGatewa2 === void 0 ? void 0 : _alipayForm$appGatewa2.split('PayServer')[1])), 1)]), _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [_createTextVNode("复制")]),
              default: _withCtx(() => [_createVNode(SvgIcon, {
                "icon-class": "copy",
                "class-name": "copy-icon",
                onClick: _cache[6] || (_cache[6] = $event => _unref(copy)(alipayForm.appGateway))
              })]),
              _: 1
            })]), _createElementVNode("div", _hoisted_5, [_createTextVNode(" 请复制该链接，按 "), _hoisted_6, _createTextVNode(" 中 pay 业务名对应的域名，替换链接标红部分；并配置到支付宝开放平台-开发设置-应用网关处; "), _createVNode(_component_a_button, {
              class: "img-btn",
              type: "link",
              onClick: _cache[7] || (_cache[7] = $event => emit('setVisible', true))
            }, {
              default: _withCtx(() => [_createTextVNode("图片指引")]),
              _: 1
            })])];
          }),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "包名：",
          required: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alipayForm.pkgList, (item, index) => {
            var _alipayForm$pkgList;
            return _openBlock(), _createElementBlock("div", {
              class: "flex-list pkg-list",
              key: index
            }, [_createVNode(_component_a_input, {
              value: item.pkg,
              "onUpdate:value": $event => item.pkg = $event,
              valueModifiers: {
                trim: true
              },
              disabled: ""
            }, null, 8, ["value", "onUpdate:value"]), index + 1 === ((_alipayForm$pkgList = alipayForm.pkgList) === null || _alipayForm$pkgList === void 0 ? void 0 : _alipayForm$pkgList.length) && index !== 0 && !item.id ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              "icon-class": "close",
              "class-name": "close-icon",
              onClick: $event => deleteAliPkg(index)
            }, null, 8, ["onClick"])) : _createCommentVNode("", true)]);
          }), 128))]), false ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            class: "add-btn",
            onClick: addAliPkg
          }, {
            icon: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "add_no_color",
              "class-name": "add-icon"
            })]),
            default: _withCtx(() => [_createTextVNode(" 新增包名 ")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});